import { render, staticRenderFns } from "./Member.vue?vue&type=template&id=0897f4c4"
import script from "./Member.vue?vue&type=script&lang=js"
export * from "./Member.vue?vue&type=script&lang=js"
import style0 from "./Member.vue?vue&type=style&index=0&id=0897f4c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports